/**
 * @prop --hover-color: Text color on hover.
 */

:host {
  --color: var(--stzh-anchornav-color, #{$colorPrimary});
  --hover-color: var(--stzh-anchornav-hover-color, #{$colorPrimary});
}

.stzh-anchornav {
  @include spaceCurve("margin-top", "section-inner");

  &__list {
    display: grid;
    gap: space("xsmall");
  }

  &__item {
    @include font("heavy");
    @include fontSize("milli");
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: space("xsmall");
    align-items: start;
    padding: space("medium") $containerMargin;
    background-color: $colorGrey10;
    color: var(--color);
    text-decoration: none;

    @include mq($from: small) {
      padding-left: $containerMarginSmall;
      padding-right: $containerMarginSmall;
    }

    @include mq($from: medium) {
      padding-left: $containerMarginMedium;
      padding-right: $containerMarginMedium;
    }

    @include mq($from: large) {
      padding-left: space("xxxlarge");
      padding-right: space("large");
    }

    &:hover {
      color: var(--hover-color);
    }
  }
}
